export default __webpack_public_path__ + "static/media/P13.3c7f7fba.png";